import { gql } from "@apollo/client";

export const UPDATE_NPID = gql`
    mutation UpdateNPIDRI(
        $input: AddNutricionParenteralRIInput!
        $screen: Int!
        )
    {
        createAndUpdateNutricionParenteralRI(
            screen: $screen
            input: $input
        ){
            idNutricionParenteralIntradialiticaRI
        }
    }
`;